import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import BackgroundOrbs from './BackgroundOrbs'
import GoogleAnalytics from '../GoogleAnalytics'

interface LayoutProps {
  children?: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen w-full flex flex-col">
      <GoogleAnalytics />
      {/* Background Effects */}
      <BackgroundOrbs />

      {/* Grain Overlay - handled in App.tsx */}

      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="flex-1 w-full relative z-[1]">{children ?? <Outlet />}</main>

      {/* Footer */}
      <Footer />
    </div>
  )
}
